
import { AuthService } from "../services/auth-service";
import AppContainer from "@/components/login/LoginContainer.vue";
import AppTitle from "@/components/login/LoginTitle.vue";
import AppText from "@/components/login/LoginText.vue";
import AppSection from "@/components/login/LoginSection.vue";
import AppButton from "@/components/login/LoginButton.vue";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";
import { ISelectItem } from "winfakt-vue-components";
import { loadLanguageAsync, getBrowserLang } from "@/setup/i18n-setup";
import { isPasswordStrongEnough, isStringEmail } from "../utils/strings";
import { HttpError } from "../utils/services/http-error";

export default FormLike.extend({
	data() {
		return {
			input: {
				firstname: "",
				lastname: "",
				companyname: "",
				email: "",
				phone: "",
				password: "",
				confirmPassword: "",
				referralCode: "",
				accountantInviteToken: "",
				lang: getBrowserLang(),
			},
			usedInputs: {
				companyname: false,
				firstname: false,
				lastname: false,
				email: false,
				phone: false,
				password: false,
				confirmPassword: false
			},
			hasError: {
				email: false,
				phone: false,
				password: false,
				confirmPassword: false
			},
			signupResult: "",
			formErrors: [] as string[],
			waitForActivation: false,
			sending: false,
			preset: "",
			isCreatingAccount: false
		};
	},
	computed: {
		langItems(): ISelectItem<string>[] {
			return [
				{text: "Nederlands", value: "nl-be"},
				{text: "Français", value: "fr"},
			];
		},
		disableFormElement(): boolean {
			return this.sending;
		},
		shownError(): string {
			return this.formErrors[0] || this.signupResult;
		}
	},
	watch: {
		"input.lang"(lang: string) {
			loadLanguageAsync(lang);
		},
		input: {
			deep: true,
			handler() {
				this.formErrors = [];
				this.signupResult = "";
			}
		},
		usedInputs: {
			deep: true,
			handler() {
				this.validate();
			}
		}
	},
	methods: {
		async submit() {
			if (!this.isValid) return;
			try {
				this.sending = true;
				await AuthService.signup(this.input);
				this.isCreatingAccount = true;
				setTimeout(async () => {
					try{
						await AuthService.login(this.input.email,this.input.password);
					}catch(err){
					}
					this.isCreatingAccount = false;
				}, 1000);
				//this.waitForActivation = true;
			} catch (err) {
				let error = err as HttpError;
				error.dontShow = true;
				this.signupResult = error.getText();
			}
			this.sending = false;
		},
		emailValidator(): boolean {
			this.hasError.email = false;
			if (!isStringEmail(this.input.email)) {
				if (this.usedInputs.email) {
					this.hasError.email = true;
					this.formErrors.push(this.$ct("errors.email-invalid").toString());
				}
				return false;
			}
			return true;
		},
		phoneValidator(): boolean {
			let re = /^[0-9 .\(\)\/\+]+$/;
			this.hasError.phone = false;
			if (!re.test(this.input.phone.toLowerCase())) {
				if (this.usedInputs.phone) {
					this.hasError.phone = true;
					this.formErrors.push(this.$ct("errors.phone-invalid").toString());
				}
				return false;
			}
			return true;
		},
		passwordValidator(): boolean {
			this.hasError.password = false;
			if (!isPasswordStrongEnough(this.input.password)) {
				if (this.usedInputs.password) {
					this.hasError.password = true;
					this.formErrors.push(this.$ct("errors.password-not-strong-enough").toString());
				}
				return false;
			}
			return true;
		},
		samePasswordValidator(): boolean {
			return true;
			/*
			this.hasError.confirmPassword = false;
			if (this.input.confirmPassword != this.input.password) {
				if (this.usedInputs.confirmPassword) {
					this.hasError.confirmPassword = true;
					this.formErrors.push(this.$ct("errors.passwords-dont-match").toString());
				}
				return false;
			}
			return true;*/
		},
		fillPresets() {
			let p = JSON.parse(window.atob(this.preset.split(".")[1]));
			this.input.companyname = p.company;
			this.input.email = p.email;
			this.input.phone = p.phone;
		}
	},
	i18nEx: {
		componentPrefix: "views.TheSignUp"
	},
	created() {
		this.validators = [
			this.emailValidator,
			this.phoneValidator,
			this.passwordValidator,
			this.samePasswordValidator
		];

		this.validate();
	},
	mounted() {
		let splashEl = document.getElementById("splash");
		if (splashEl) {
			splashEl.remove();
		}
		if (this.$router.currentRoute.query.preset) {
			this.preset = this.$router.currentRoute.query.preset.toString();
			this.fillPresets();
		}

		const query = this.$router.currentRoute.query;
		if (query.companyname) {
			this.input.companyname = String(query.companyname);
		}
		if (query.email) {
			this.input.email = String(query.email);
		}
		if (query.phone) {
			this.input.phone = String(query.phone);
		}
		if (query.ref) {
			this.input.referralCode = String(query.ref);
		}
		if (query.accinvite) {
			this.input.accountantInviteToken = String(query.accinvite);
		}
	},
	components: {
		AppContainer,
		AppSection,
		AppText,
		AppTitle,
		AppButton
	}
});
